export enum CompanyTheme {
  Blue = 'blue',
  Purple = 'purple',
  Orange = 'orange',
  Green = 'green',
  Black = 'black',
}
